import nameof from "ts-nameof.macro";

import { appendReduxParts } from "infrastructure/store";

import { appSaga } from "./app.saga";
import { appTranslation, settings, appNotification } from "./app.slice";
import { IAppTranslationState, ISettingsState } from "./app.state";

export * from "./app.actions";
export * from "./app.state";
export * from "./app.api";

export * from "./common";
export { AppUserContext, UserContext, UserProvider } from "./user-provider";

appendReduxParts(
  [
    {
      reducerName: appTranslation.name,
      reducer: appTranslation.reducer,
      transformation: { path: nameof.toArray<IAppTranslationState>(o => [o.isInitialized, o.isLoading]) },
      persistLocally: true
    },
    {
      reducerName: settings.name,
      reducer: settings.reducer,
      transformation: { path: [nameof.full<ISettingsState>(o => o.localSettings.isLocaleChanging)] },
      persistLocally: true
    },
    {
      reducerName: appNotification.name,
      reducer: appNotification.reducer
    }
  ],
  [appSaga()]
);
